module.exports = __webpack_public_path__ + "img/DSC_0092.fdd71ea1.jpg";